import { computed, ref, Ref, watch } from 'vue'
import { orderBy } from 'lodash'
import { usePagination } from './Pagination.composable'

type SortDirection = 'asc' | 'desc'

type PagedResult<T = any> = {
	items: T[]
	total: number
}

type UseRegistersOptions = {
	onTextFilterChange?: () => void
}

export const useRegisters = (options: UseRegistersOptions = {}) => {
	const pagination = usePagination()

	const disableSaveButton = ref(false)
	const isEdit = ref(false)
	const isCreate = ref(false)
	const modelList = ref<any[]>([])
	const orderTable = ref<string[]>([])
	const showForm = ref(false)
	const titleForm = ref('')
	const textFilter = ref('')
	const sortBy = ref<string | undefined>(undefined)
	const sortType = ref<SortDirection | undefined>(undefined)

	const sortedData = computed(() => {
		return orderBy(modelList.value, sortBy.value, [sortType.value as SortDirection])
	})

	const isDeleteButtonDisabled = computed(() => {
		return (
			modelList.value.filter((f: any) => f.isCheckedToDelete).map((m: any) => m.id).length === 0
		)
	})

	const modelsIdWithCheckedToDelete = computed<string[]>(() => {
		return modelList.value.filter((f: any) => f.isCheckedToDelete).map((m: any) => m.id)
	})

	const modelsToBeShowedAndTotal = computed<PagedResult>(() => {
		let modelsFiltred = sortedData.value

		const filter = textFilter.value.toLowerCase()
		modelsFiltred = modelsFiltred.filter((item: any) => {
			const atualModel = Object.values(item).join(' ')
			return atualModel.toLowerCase().includes(filter)
		})

		return {
			items: modelsFiltred.slice(pagination.atualStartIndex.value, pagination.atualEndIndex.value),
			total: modelsFiltred.length,
		}
	})

	const modelsToBeShowedAndTotalPagination = computed<PagedResult>(() => {
		const modelsFiltred = sortedData.value
		return {
			items: modelsFiltred.slice(pagination.atualStartIndex.value, pagination.atualEndIndex.value),
			total: modelsFiltred.length > 0 ? modelsFiltred[0].totalRegistros : 0,
		}
	})

	function cleanModel(model: Ref<Record<string, any>>) {
		for (const propertieName in model.value) {
			if (Array.isArray(model.value[propertieName])) {
				model.value[propertieName] = []
			} else if (typeof model.value[propertieName] === 'boolean') {
				model.value[propertieName] = false
			} else if (typeof model.value[propertieName] === 'number') {
				model.value[propertieName] = 0
			} else {
				model.value[propertieName] = ''
			}
		}
	}

	watch(textFilter, () => {
		if (options.onTextFilterChange) {
			options.onTextFilterChange()
		}
	})

	return {
		...pagination,

		disableSaveButton,
		isEdit,
		isCreate,
		modelList,
		orderTable,
		showForm,
		titleForm,
		textFilter,
		sortBy,
		sortType,

		sortedData,
		isDeleteButtonDisabled,
		modelsIdWithCheckedToDelete,
		modelsToBeShowedAndTotal,
		modelsToBeShowedAndTotalPagination,

		cleanModel,
	}
}
